import { SortTypeEnum } from "@repo/helpers";
import { RepFieldAuditHistory } from "@repo/models";
import { Column, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";

import { useRepFieldAuditQueries } from "../../../api/repFieldAuditApi";
import { useVerbiageQuery } from "../../../api/verbiageApi";

const columns = [
	new Column("User", "user"),
	new Column("Comments", "comments"),
	new Column("Coordinates").withFormat((item) => `${item.lat}, ${item.lon}`),
	new OriginalTimezoneDateColumn("Created On", "createdOn").dateOnly().withSortBy(SortTypeEnum.descending),
] as Column<RepFieldAuditHistory>[];

interface Props {
	fieldAuditId: number | undefined;
}

export default function FieldAuditHistoryGridBasic(props: Props) {
	const { useFieldAuditHistories } = useRepFieldAuditQueries();
	const { data, loading, clearQuery } = useFieldAuditHistories(props.fieldAuditId);
	const { fieldAudit } = useVerbiageQuery();

	if (props.fieldAuditId == null) return null;

	return (
		<GridPreLoaded<RepFieldAuditHistory>
			keyProperty="id"
			title={`${fieldAudit} History`}
			columns={columns}
			values={data ?? []}
			loading={loading}
			getData={clearQuery}
		/>
	);
}
